<template>
   <div style="background-color: #fff">
      <div class="container">
         <div
            id="topics"
            :class="breakpoint">
            <div class="d-none d-md-block">
               <table class="text-center">
                  <tbody>
                     <tr>
                        <td class="fit">
                           <object
                              data="/wp-content/themes/findforsikring_2015-sommer/images/icons/bil.svg"
                              type="image/svg+xml"
                              width="105px"
                              height="67px"
                              style="margin-right: -32px" />
                        </td>
                        <td class="fit">
                           <object
                              data="/wp-content/themes/findforsikring_2015-sommer/images/icons/hus.svg"
                              type="image/svg+xml"
                              width="90px"
                              height="77px"
                              style="margin-right: -18px" />
                        </td>
                        <td class="fit">
                           <object
                              data="/wp-content/themes/findforsikring_2015-sommer/images/icons/laptop.svg"
                              type="image/svg+xml"
                              width="94px"
                              height="68px"
                              style="margin-right: -16px" />
                        </td>
                        <td class="fit">
                           <object
                              data="/wp-content/themes/findforsikring_2015-sommer/images/icons/skilt.svg"
                              type="image/svg+xml"
                              width="86px"
                              height="75px"
                              style="margin-right: -8px" />
                        </td>
                     </tr>
                     <tr>
                        <td style="vertical-align: top">
                           <a
                              href="https://www.findforsikring.dk/billig-bilforsikring/"
                              style="margin: 0; text-decoration: none">
                              <span class="title">Billig bilforsikring</span>
                              <p>
                                 En bilforsikring består af en kasko- og ansvarsforsikring. Ansvarsforsikringen er
                                 lovpligtig, mens kaskoforsikringen er frivillig.
                              </p>
                           </a>
                        </td>
                        <td style="vertical-align: top">
                           <a
                              href="https://www.findforsikring.dk/husforsikring/"
                              style="margin: 0; text-decoration: none">
                              <span class="title">Billig husforsikring</span>
                              <p>
                                 En husforsikring dækker skader på din bolig i tilfælde af brand, skybrud, lynnedslag,
                                 indbrud, hærværk og storm.
                              </p>
                           </a>
                        </td>
                        <td style="vertical-align: top">
                           <a
                              href="https://www.findforsikring.dk/indboforsikring/"
                              style="margin: 0; text-decoration: none">
                              <span class="title">Billig indboforsikring</span>
                              <p>
                                 En indboforsikring dækker skader på dit indbo ved brand, vandskade, tyveri, indbrud og
                                 indeholder ofte en ansvarsforsikring.
                              </p>
                           </a>
                        </td>
                        <td style="vertical-align: top">
                           <a
                              href="https://www.findforsikring.dk/billig-ulykkesforsikring/"
                              style="margin: 0; text-decoration: none">
                              <span class="title">Billig ulykkesforsikring</span>
                              <p>
                                 En ulykkesforsikring dækker personskader, hvis der skulle ske noget med dig eller nogle
                                 af dine familiemedlemmer.
                              </p>
                           </a>
                        </td>
                     </tr>
                  </tbody>
               </table>
            </div>

            <div class="d-none d-sm-block d-md-none">
               <table
                  class="text-center"
                  style="margin-bottom: 25px">
                  <tbody>
                     <tr>
                        <td>
                           <object
                              data="/wp-content/themes/findforsikring_2015-sommer/images/icons/bil.svg"
                              type="image/svg+xml"
                              width="105px"
                              height="67px"
                              style="margin-right: -32px" />
                        </td>
                        <td>
                           <object
                              data="/wp-content/themes/findforsikring_2015-sommer/images/icons/hus.svg"
                              type="image/svg+xml"
                              width="90px"
                              height="77px"
                              style="margin-right: -18px" />
                        </td>
                     </tr>
                     <tr>
                        <td>
                           <a
                              href="https://www.findforsikring.dk/billig-bilforsikring/"
                              style="margin: 0; text-decoration: none">
                              <span class="title">Billig bilforsikring</span>
                              <p>
                                 En bilforsikring består af en kasko- og ansvarsforsikring. Ansvarsforsikringen er
                                 lovpligtig, mens kaskoforsikringen er frivillig.
                              </p>
                           </a>
                        </td>
                        <td>
                           <a
                              href="https://www.findforsikring.dk/husforsikring/"
                              style="margin: 0; text-decoration: none">
                              <span class="title">Billig husforsikring</span>
                              <p>
                                 En husforsikring dækker skader på din bolig i tilfælde af brand, skybrud, lynnedslag,
                                 indbrud, hærværk og storm.
                              </p>
                           </a>
                        </td>
                     </tr>
                  </tbody>
               </table>
               <table class="text-center">
                  <tbody>
                     <tr>
                        <td>
                           <object
                              data="/wp-content/themes/findforsikring_2015-sommer/images/icons/laptop.svg"
                              type="image/svg+xml"
                              width="94px"
                              height="68px"
                              style="margin-right: -16px" />
                        </td>
                        <td>
                           <object
                              data="/wp-content/themes/findforsikring_2015-sommer/images/icons/skilt.svg"
                              type="image/svg+xml"
                              width="86px"
                              height="75px"
                              style="margin-right: -8px" />
                        </td>
                     </tr>
                     <tr>
                        <td>
                           <a
                              href="https://www.findforsikring.dk/indboforsikring/"
                              style="margin: 0; text-decoration: none">
                              <span class="title">Billig indboforsikring</span>
                              <p>
                                 En indboforsikring dækker skader på dit indbo ved brand, vandskade, tyveri, indbrud og
                                 indeholder ofte en ansvarsforsikring.
                              </p>
                           </a>
                        </td>
                        <td>
                           <a
                              href="https://www.findforsikring.dk/billig-ulykkesforsikring/"
                              style="margin: 0; text-decoration: none">
                              <span class="title">Billig ulykkesforsikring</span>
                              <p>
                                 En ulykkesforsikring dækker personskader, hvis der skulle ske noget med dig eller nogle
                                 af dine familiemedlemmer.
                              </p>
                           </a>
                        </td>
                     </tr>
                  </tbody>
               </table>
            </div>

            <div class="d-block d-sm-none">
               <table class="text-center">
                  <tbody>
                     <tr>
                        <td style="vertical-align: top; padding: 0 0 0 10px">
                           <object
                              data="/wp-content/themes/findforsikring_2015-sommer/images/icons/bil.svg"
                              type="image/svg+xml"
                              width="55px"
                              height="35px" />
                        </td>
                        <td style="padding: 0 0 0 5px; text-align: left">
                           <a
                              href="https://www.findforsikring.dk/billig-bilforsikring/"
                              style="margin: 0; text-decoration: none">
                              <span class="title">Billig bilforsikring</span>
                              <p style="margin: 0">
                                 En bilforsikring består af en kasko- og ansvarsforsikring. Ansvarsforsikringen er
                                 lovpligtig, mens kaskoforsikringen er frivillig.
                              </p>
                           </a>
                        </td>
                     </tr>
                     <tr>
                        <td style="vertical-align: top; padding: 0 0 0 10px">
                           <object
                              data="/wp-content/themes/findforsikring_2015-sommer/images/icons/hus.svg"
                              type="image/svg+xml"
                              width="55px"
                              height="47px" />
                        </td>
                        <td style="padding: 0 0 0 5px; text-align: left">
                           <a
                              href="https://www.findforsikring.dk/husforsikring/"
                              style="margin: 0; text-decoration: none">
                              <span class="title">Billig husforsikring</span>
                              <p style="margin: 0">
                                 En husforsikring dækker skader på din bolig i tilfælde af brand, skybrud, lynnedslag,
                                 indbrud, hærværk og storm.
                              </p>
                           </a>
                        </td>
                     </tr>
                     <tr>
                        <td style="vertical-align: top; padding: 0 0 0 10px">
                           <object
                              data="/wp-content/themes/findforsikring_2015-sommer/images/icons/laptop.svg"
                              type="image/svg+xml"
                              width="55px"
                              height="40px" />
                        </td>
                        <td style="padding: 0 0 0 5px; text-align: left">
                           <a
                              href="https://www.findforsikring.dk/indboforsikring/"
                              style="margin: 0; text-decoration: none">
                              <span class="title">Billig indboforsikring</span>
                              <p style="margin: 0">
                                 En indboforsikring dækker skader på dit indbo ved brand, vandskade, tyveri, indbrud og
                                 indeholder ofte en ansvarsforsikring.
                              </p>
                           </a>
                        </td>
                     </tr>
                     <tr>
                        <td style="vertical-align: top; padding: 0 0 0 10px">
                           <object
                              data="/wp-content/themes/findforsikring_2015-sommer/images/icons/skilt.svg"
                              type="image/svg+xml"
                              width="55px"
                              height="48px" />
                        </td>
                        <td style="padding: 0 0 0 5px; text-align: left">
                           <a
                              href="https://www.findforsikring.dk/billig-ulykkesforsikring/"
                              style="margin: 0; text-decoration: none">
                              <span class="title">Billig ulykkesforsikring</span>
                              <p style="margin: 0">
                                 En ulykkesforsikring dækker personskader, hvis der skulle ske noget med dig eller nogle
                                 af dine familiemedlemmer.
                              </p>
                           </a>
                        </td>
                     </tr>
                  </tbody>
               </table>
            </div>
            <hr
               class="topic-divider"
               style="margin: 3em 0" />
            <div class="row bank-topics">
               <a
                  class="findbank-link fw-semibold"
                  href="https://www.findbank.dk"
                  title="Gå til Findbank.dk"
                  style="font-size: 150%; margin-bottom: 2em; text-decoration: none">
                  Find billigste bank
               </a>
               <!--            <heading-->
               <!--               size="180%"-->
               <!--               :heading-style="{marginBottom: '2em'}"-->
               <!--               :link="{href: 'https://www.findbank.dk', title: 'Gå til Findbank.dk'}"-->
               <!--               style="display:block;width: 100%;">-->
               <!--               <span class="line">Find</span> billigste bank-->
               <!--            </heading>-->
               <div class="d-none d-md-block col-md-3">
                  <object
                     data="https://www.findforsikring.dk/wp-content/themes/findforsikring_2015-sommer/images/graphics/draabe_med_skygge.svg"
                     width="45px"
                     height="39px"
                     style="margin-right: -14px"
                     type="image/svg+xml" />
               </div>
               <div class="d-none d-md-block col-md-3">
                  <object
                     data="https://www.findforsikring.dk/wp-content/themes/findforsikring_2015-sommer/images/graphics/draabe_med_skygge.svg"
                     width="45px"
                     height="39px"
                     style="margin-right: -14px"
                     type="image/svg+xml" />
               </div>
               <div class="d-none d-md-block col-md-3">
                  <object
                     data="https://www.findforsikring.dk/wp-content/themes/findforsikring_2015-sommer/images/graphics/draabe_med_skygge.svg"
                     width="45px"
                     height="39px"
                     style="margin-right: -14px"
                     type="image/svg+xml" />
               </div>
               <div class="d-none d-md-block col-md-3">
                  <object
                     data="https://www.findforsikring.dk/wp-content/themes/findforsikring_2015-sommer/images/graphics/draabe_med_skygge.svg"
                     width="45px"
                     height="39px"
                     style="margin-right: -14px"
                     type="image/svg+xml" />
               </div>
               <div class="col-12 col-sm-6 col-md-3">
                  <a href="https://www.findbank.dk/billigste-andelsboliglaan/">Billigste andelsboliglån</a>
               </div>
               <div class="col-12 col-sm-6 col-md-3">
                  <a href="https://www.findbank.dk/billigste-boliglaan/">Billigste boliglån</a>
               </div>
               <div class="col-12 col-sm-6 col-md-3">
                  <a href="https://www.findbank.dk/billigste-realkreditlaan/">Billigste realkreditlån</a>
               </div>
               <div class="col-12 col-sm-6 col-md-3">
                  <a href="https://www.findbank.dk/billigste-huslaan/">Billigste huslån</a>
               </div>
               <div class="col-12 col-sm-6 col-md-3">
                  <a href="https://www.findbank.dk/banklaan/">Banklån</a>
               </div>
               <div class="col-12 col-sm-6 col-md-3">
                  <a href="https://www.findbank.dk/billigste-obligationslaan/">Billigste obligationslån</a>
               </div>
               <div class="col-12 col-sm-6 col-md-3">
                  <a href="https://www.findbank.dk/skift-bank/">Skift bank</a>
               </div>
               <div class="col-12 col-sm-6 col-md-3">
                  <a href="https://www.findbank.dk/kreditforeningslaan/">Kreditforeningslån</a>
               </div>
               <div class="col-12 col-sm-6 col-md-3">
                  <a href="https://www.findbank.dk/forbrugslaan/">Forbrugslån</a>
               </div>
               <div class="col-12 col-sm-6 col-md-3">
                  <a href="https://www.findbank.dk/hvad-kan-jeg-koebe-bolig-for/">Hvad kan jeg købe bolig for?</a>
               </div>
               <div class="col-12 col-sm-6 col-md-3">
                  <a href="https://www.findbank.dk/hvad-kan-jeg-koebe-bolig-for/#boligkoebsberegner">
                     Boligkøbsberegner
                  </a>
               </div>
               <div class="col-12 col-sm-6 col-md-3">
                  <a href="https://www.findbank.dk/raadighedsbeloeb/">Rådighedsbeløb</a>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
   name: 'MaterialTopics',
   computed: {
      ...mapGetters(['breakpoint']),
   },
};
</script>

<style lang="scss" scoped>
//noinspection CssUnknownTarget
@import '~/colors.scss';

#topics {
   color: $ff-dark-blue;
   font-size: 17px;
   padding: 3em 0;

   &.sm {
      font-size: 15px;
   }

   &.xs,
   &.sm {
      font-size: 13px;

      span.title {
         margin: 0;
         padding-bottom: 10px;

         &:before {
            top: 1.2em;
         }
      }

      tr:not(:first-child) {
         td {
            padding-top: 20px !important;
         }
      }
   }

   span.title {
      position: relative;
      font-family: 'proxima-nova-condensed', sans-serif;
      font-size: 110%;
      margin: 0.8em 0;
      text-align: left;
      line-height: 1.3;

      //&:before {
      //   content: ' ';
      //   position: absolute;
      //   left: 0;
      //   top: 1.3em;
      //   width: 40px;
      //   height: 3px;
      //   background-color: $ff-dark-blue;
      //}
   }

   td.fit {
      /*width:1%;*/
      /*white-space:nowrap;*/
      width: 25%;
   }

   tr {
      td {
         border-color: #fff;
         border-right: 4px solid #fff;
         border-left: 4px solid #fff;
         border-radius: 10px;
         padding: 10px;
      }

      &:first-child {
         td {
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;
            padding: 20px;
         }
      }

      &:last-child {
         td {
            border-top-left-radius: 0;
            border-top-right-radius: 0;
         }
      }
   }

   .title {
      display: block;
      //font-family: 'Amaranth', sans-serif;
      font-weight: bold;
   }

   tr:nth-child(2) td {
      p {
         font-size: 100%;
         text-align: left;
         text-decoration: none;
         //font-family: 'Lato', sans-serif;
      }
   }

   a {
      color: $ff-dark-blue;
      display: inline-block;
      font-size: 15px;
   }

   .bank-topics {
      * {
         text-align: center;
      }

      a:not(.findbank-link) {
         margin-top: 0.25em;
         font-weight: normal;
         font-style: italic;
         text-decoration: underline;
      }
   }
}
</style>
